jQuery(document).ready(function ($) {
  
  // Fix for issue with force ship week selection on products where a variant is OOS
  // the theme js disables all variant options by default on change. Because there's no value
  // for the ship week option (since we unset it to force the customer to select it) there's an error
  // and the theme js never completes to restore access to the dropdown options
  // This works around that issue by checking to see if there's a ship week and if the value is not set and if so,
  // re-enables all the dropdowns to allow the customer to finish making selections.
  // once they select values for both options then the theme.js is able to correctly handle the variant and
  // all the out of stock logic works
  document.addEventListener('variant:change', function(variant) {
    console.log("checking dropdowns");
    if($('div.variant-wrapper[data-type="dropdown"]').length === 1 && !$('div.variant-dropdown-wrap[data-handle="ship-week"] > select')) {
      // only run if there's more than one variant option dropdown and one of them is for ship week
      console.log("aborting ship week dropdown variant:change");
      return false;
    }

    let shipWeekSelect = $('div.variant-dropdown-wrap[data-handle="ship-week"] > select');

    // if ship week doesn't have a value, enable all of the dropdown options for the variant as the user hasn't selected
    // both.
    // this works around the theme code which disables all options by default on variant change, making it impossible for the user
    // to select both options as we have short circuited the process to force selection of ship week in certain cases.
    if(shipWeekSelect.val() === null) {
      console.log("No ship week value, enabling all dropdown options");
      let variantDropdownOptions = $('div.variant-wrapper[data-type="dropdown"]  select > option');

      variantDropdownOptions.each(function() {
        $( this ).prop("disabled", false);
        $( this ).removeAttr('disabled');
      });
    }    
  });
  
  
  // Toggle the Back In Stock form on variant change. The theme's
  // <block-variant-picker> fires a namespaced, bubbling
  // 'variant:change:<sectionId>:<productId>' event, so bind that per picker.
  function toggleNotifyForm(variant) {
    if (variant && variant.available === false) {
      $('.notify_form .notify_variant_id').val(variant.id);
      $('.notify_form_wrap').show();
    } else {
      $('.notify_form_wrap').hide();
    }
  }

  var boundVariantEvents = {};
  function bindNotifyForm() {
    document.querySelectorAll('block-variant-picker[data-section-id][data-product-id]').forEach(function (picker) {
      var eventName = 'variant:change:' + picker.dataset.sectionId + ':' + picker.dataset.productId;
      if (boundVariantEvents[eventName]) return;
      boundVariantEvents[eventName] = true;
      // Event bubbles to document; listen there so it survives picker re-renders.
      document.addEventListener(eventName, function (e) {
        toggleNotifyForm(e.detail && e.detail.variant);
      });
    });
  }

  bindNotifyForm();
  document.addEventListener('shopify:section:load', bindNotifyForm);


});